// extracted by mini-css-extract-plugin
module.exports = {"iconsBlock":"IconsBlock_iconsBlock__1d26W","info":"IconsBlock_info__29X76","item":"IconsBlock_item__1z1wc"};